import { useEffect } from 'react';
import {
  subscribeToCommands,
  wsConnect,
  selectConnectionStatus,
} from './spectrasWebSocketServerSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

const SpectrasWebSocketServer = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const connectionStatus = useAppSelector(selectConnectionStatus);

  useEffect(() => {
    if (!user) return;
    dispatch(wsConnect());
  }, [dispatch, user]);

  useEffect(() => {
    if (connectionStatus) {
      if (!user) return;
      dispatch(
        subscribeToCommands({
          user_id: user.id,
        })
      );
    }
  }, [dispatch, connectionStatus, user]);

  return null;
};

export default SpectrasWebSocketServer;
